var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"histories"},[_c('div',{staticClass:"page_title_container flex justify-start w-full"},[_vm._v(" Transactions ")]),_c('div',{staticClass:"page_content"},[_c('div',{staticClass:"tab_container"},[_vm._v(" tab "),_c('div',{attrs:{"id":"people"}})]),_c('div',{staticClass:"detail_view"},[_vm._v(" detail ")])])])
}]

export { render, staticRenderFns }